import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import stores from 'cd-eft/models/Stores';
import { PointTranslationVM } from './PointTranslationVM';
import { DeltaCoordinates } from '../PointTranslationByDelta';
import { PointCoordinates } from '../PointTranslationByCoordinates';
import { TranslationRotation } from '../PointTranslationRotation';
import { Popup } from 'cd-eft/components/common/Popup';
import { mdiExitToApp } from '@mdi/js';
import './PointTranslation.scss';

const setStore = stores.AppStore.surveyEngineeringStore;
const designStore = stores.AppStore.designStore;
const PointTranslationComponent = (props) => {
  const vm = useRef(new PointTranslationVM(props)).current;

  useEffect(() => {
    // if no survey displayed from summary
    if (setStore.selectedSurveysInfo.length === 0) {
      // display all xyz surveys from summary
      vm.displayAllXYZSurveys();
    }
  }, []);

  return (
    <>
      <form className="point-translation-container" onSubmit={vm.handleSubmit}>
        <h4 className="my-4">Point Translation</h4>
        <div className="my-4">
          <select
            className="usa-select"
            name="point-translation"
            id="point-translation"
            value={vm.translationOption}
            onChange={vm.selectTranslateOptionHandler}
          >
            <option value={1}>Translate by &Delta;Coordinates</option>
            <option value={2}>Translate using Point Coordinates</option>
            <option value={3}>Translate &amp; Rotate using Point Coordinates</option>
          </select>
        </div>
        <fieldset disabled={!designStore.hasProject()}>
          {vm.translationOption === 1 && <DeltaCoordinates setFormError={vm.setFormError} />}
          {vm.translationOption === 2 && <PointCoordinates setFormError={vm.setFormError} />}
          {vm.translationOption === 3 && <TranslationRotation setFormError={vm.setFormError} />}

          {vm.formError !== '' && (
            <div className="usa-error-message nobr text-center mt-4" id={`point-translation-form--err`} role="alert">
              {vm.formError}
            </div>
          )}
        </fieldset>
        <div className="text-right mt-5">
          {setStore.translationOptionApplied !== 0 ? (
            <>
              <input type="submit" className="usa-button" value="hiddenSubmit" hidden />
              <button className="usa-button" onClick={vm.returnToOriginalPoints}>
                Revert to Original Points
              </button>
              <button className="usa-button" onClick={vm.acceptTranslation}>
                Check Table View
              </button>
            </>
          ) : (
            <input type="submit" className="usa-button" value="Apply" disabled={!designStore.hasProject()} />
          )}

          <button className="usa-button usa-button--outline m-0" onClick={vm.onCancelPointTranslation}>
            Close
          </button>
        </div>
      </form>

      {/* popup */}
      {vm.pointTranslationDialogIsOpen && (
        <Popup
          icon={mdiExitToApp}
          trigger={vm.pointTranslationDialogIsOpen}
          setTrigger={vm.closeDialog}
          title="You have unsaved changes"
          handleCancel={vm.fromPopupKeepTranslation}
          cancelText="Keep translation"
          handleOK={vm.fromPopupRevertToOriginal}
          okText="Revert to original"
        >
          <p>You have applied point translation.</p>
          <p>Do you want to keep it or revert to origin points?</p>
        </Popup>
      )}
    </>
  );
};

export const PointTranslation = observer(PointTranslationComponent);
